"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.streamParser = void 0;
exports.createStreamParser = createStreamParser;
const bole_1 = __importDefault(require("bole"));
const ndjson_1 = __importDefault(require("ndjson"));
exports.streamParser = createStreamParser();
function createStreamParser() {
    const sp = ndjson_1.default.parse();
    bole_1.default.output([
        {
            level: 'debug', stream: sp,
        },
    ]);
    return sp;
}
//# sourceMappingURL=streamParser.js.map